// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../shared/font/gteestiprodisplay_bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../shared/font/gteestiprodisplay_light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../shared/images/roadMap_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GteDisplayBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "GteDisplayLight";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-style: normal;
  font-weight: normal;
}
.roadMap_body__OiyJk {
  padding: 100px 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center no-repeat;
  background-color: #000;
  background-size: cover;
  margin-top: 120px;
}

.roadMap_wrapperMain__RGBpA {
  margin: 250px 0 150px 0;
}

.roadMap_line__fjw6S {
  background: linear-gradient(90deg, #9747FF 0%, #0CD1E0 100%);
  height: 8px;
  width: 100%;
  border-radius: 10px;
  margin-top: 25px;
  position: relative;
}
.roadMap_line__fjw6S .roadMap_point__91jRP {
  background: #13CBE2;
  border-radius: 50px;
  width: 20px;
  height: 29px;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}
.roadMap_line__fjw6S .roadMap_point__91jRP .roadMap_pointWrapper__5Sf6A {
  position: relative;
}
.roadMap_line__fjw6S .roadMap_point__91jRP .roadMap_pointItem__rOzdL {
  position: absolute;
  bottom: 5px;
  left: 0;
}
.roadMap_line__fjw6S .roadMap_point__91jRP .roadMap_pointItem__rOzdL h4 {
  width: 100%;
  text-wrap: nowrap;
  font-size: 26px;
  font-weight: 500;
  background: linear-gradient(90deg, #9747FF 0%, #0CD1E0 100%);
  font-family: GteDisplayBold;
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
}
.roadMap_line__fjw6S .roadMap_point__91jRP .roadMap_pointItem__rOzdL .roadMap_pointItemWrapper__SMPia {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  grid-gap: 4px;
  margin-top: 8px;
}
.roadMap_line__fjw6S .roadMap_point__91jRP .roadMap_pointItem__rOzdL .roadMap_pointItemWrapper__SMPia p {
  font-family: GteDisplayLight;
  color: #fff;
  text-wrap: none;
  white-space: nowrap;
  overflow-wrap: normal;
  word-wrap: normal;
  hyphens: none;
  position: relative;
  padding-left: 12px;
}
.roadMap_line__fjw6S .roadMap_point__91jRP .roadMap_pointItem__rOzdL .roadMap_pointItemWrapper__SMPia p::before {
  content: "";
  display: block;
  width: 5px;
  height: 2px;
  background: #fff;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
}
.roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(2) {
  transform: translate(250px, -50%);
}
.roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(2) .roadMap_pointItem__rOzdL {
  top: 55px;
}
.roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(3) {
  transform: translate(620px, -50%);
}
.roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) {
  transform: translate(900px, -50%);
}
.roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) .roadMap_pointItem__rOzdL {
  top: 55px;
}
.roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(5) {
  transform: translate(900px, -50%);
}

.roadMap_header__b\\+a-v {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  grid-gap: 10px;
  color: #111827;
  font-family: Inter;
}
.roadMap_header__b\\+a-v h3 {
  font-size: 48px;
  font-weight: 700;
  background: linear-gradient(90deg, #9747FF 0%, #0CD1E0 100%);
  font-family: GteDisplayBold;
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  text-transform: uppercase;
}
.roadMap_header__b\\+a-v p {
  font-family: GteDisplayLight;
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  color: #ffffff;
}

@media (max-width: 1450px) {
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(2) {
    transform: translate(200px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(3) {
    transform: translate(550px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) {
    transform: translate(750px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(5) {
    transform: translate(850px, -50%);
  }
}
@media (max-width: 1205px) {
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(2) {
    transform: translate(100px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) {
    transform: translate(700px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) .roadMap_pointItem__rOzdL {
    top: 55px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(5) {
    transform: translate(850px, -50%);
  }
}
@media (max-width: 1024px) {
  .roadMap_line__fjw6S .roadMap_pointItem__rOzdL {
    width: 300px;
  }
  .roadMap_line__fjw6S .roadMap_pointItem__rOzdL h4 {
    font-size: 22px !important;
  }
  .roadMap_line__fjw6S .roadMap_pointItem__rOzdL p {
    font-size: 15px !important;
    white-space: normal !important;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(3) {
    transform: translate(500px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) {
    transform: translate(600px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) .roadMap_pointItem__rOzdL {
    top: 55px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(5) {
    transform: translate(850px, -50%);
  }
}
@media (max-width: 960px) {
  .roadMap_line__fjw6S .roadMap_pointItem__rOzdL h4 {
    font-size: 22px !important;
  }
  .roadMap_line__fjw6S .roadMap_pointItem__rOzdL p {
    font-size: 15px !important;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(2) {
    transform: translate(250px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(2) .roadMap_pointItem__rOzdL {
    top: 55px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(3) {
    transform: translate(420px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) {
    transform: translate(630px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) .roadMap_pointItem__rOzdL {
    top: 55px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(5) {
    transform: translate(750px, -50%);
  }
}
@media (max-width: 960px) {
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(2) {
    transform: translate(150px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(2) .roadMap_pointItem__rOzdL {
    top: 55px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(3) {
    transform: translate(350px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) {
    transform: translate(530px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) .roadMap_pointItem__rOzdL {
    top: 55px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(5) {
    transform: translate(680px, -50%);
  }
}
@media (max-width: 840px) {
  .roadMap_line__fjw6S .roadMap_pointItem__rOzdL h4 {
    font-size: 20px !important;
  }
  .roadMap_line__fjw6S .roadMap_pointItem__rOzdL p {
    font-size: 14px !important;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP {
    width: 15px;
    height: 22px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(2) {
    transform: translate(100px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(2) .roadMap_pointItem__rOzdL {
    top: 55px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(3) {
    transform: translate(300px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) {
    transform: translate(500px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) .roadMap_pointItem__rOzdL {
    top: 55px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(5) {
    transform: translate(630px, -50%);
  }
}
@media (max-width: 840px) {
  .roadMap_line__fjw6S .roadMap_pointItem__rOzdL h4 {
    font-size: 20px !important;
  }
  .roadMap_line__fjw6S .roadMap_pointItem__rOzdL p {
    font-size: 14px !important;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(3) {
    transform: translate(275px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) {
    transform: translate(450px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) .roadMap_pointItem__rOzdL {
    top: 55px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(5) {
    transform: translate(550px, -50%);
  }
}
@media (max-width: 700px) {
  .roadMap_line__fjw6S {
    height: 4px;
  }
  .roadMap_line__fjw6S .roadMap_pointItem__rOzdL h4 {
    font-size: 18px !important;
  }
  .roadMap_line__fjw6S .roadMap_pointItem__rOzdL p {
    font-size: 12px !important;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP {
    width: 10px;
    height: 15px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(2) .roadMap_pointItem__rOzdL {
    top: 30px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(3) {
    transform: translate(250px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) {
    transform: translate(400px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) .roadMap_pointItem__rOzdL {
    top: 30px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(5) {
    transform: translate(500px, -50%);
  }
}
@media (max-width: 635px) {
  .roadMap_line__fjw6S {
    height: 4px;
  }
  .roadMap_line__fjw6S .roadMap_pointItem__rOzdL h4 {
    font-size: 18px !important;
  }
  .roadMap_line__fjw6S .roadMap_pointItem__rOzdL p {
    font-size: 12px !important;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(3) {
    transform: translate(250px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) {
    transform: translate(350px, -50%);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) .roadMap_pointItem__rOzdL {
    top: 30px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(5) {
    transform: translate(450px, -50%);
  }
}
@media (max-width: 430px) {
  .roadMap_body__OiyJk {
    padding-bottom: 50px;
  }
  .roadMap_pointItem__rOzdL {
    width: 180px !important;
  }
  .roadMap_wrapperMain__RGBpA {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .roadMap_line__fjw6S {
    width: 4px;
    height: 75vh;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP {
    left: 50%;
    top: 0;
    transform: translate(-50%, 0);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP .roadMap_pointItem__rOzdL {
    left: 150%;
    top: 0 !important;
    z-index: 1000;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP .roadMap_pointItem__rOzdL h4 {
    font-size: 21px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP .roadMap_pointItem__rOzdL p {
    font-size: 15px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(2) {
    transform: translate(-50%, 18vh);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(2) .roadMap_pointItem__rOzdL {
    left: -180px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(3) {
    transform: translate(-50%, 35vh);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) {
    transform: translate(-50%, 53vh);
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(4) .roadMap_pointItem__rOzdL {
    left: -180px;
  }
  .roadMap_line__fjw6S .roadMap_point__91jRP:nth-child(5) {
    transform: translate(-50%, 73vh);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/roadMap/roadMap.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,8BAAA;EACA,+DAAA;EACA,kBAAA;EACA,mBAAA;AACF;AAEA;EACE,gBAAA;EACA,oEAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,4DAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;AACE;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,6BAAA;AACJ;AACI;EACE,kBAAA;AACN;AAEI;EACE,kBAAA;EACA,WAAA;EACA,OAAA;AAAN;AAEM;EACE,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,4DAAA;EACA,2BAAA;EACA,oCAAA;EACA,6BAAA;AAAR;AAGM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;AADR;AAEQ;EACE,4BAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAAV;AACU;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,6BAAA;AACZ;AAKI;EACE,iCAAA;AAHN;AAKM;EACE,SAAA;AAHR;AAMI;EACE,iCAAA;AAJN;AAMI;EACE,iCAAA;AAJN;AAKM;EACE,SAAA;AAHR;AAMI;EACE,iCAAA;AAJN;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AARF;AAUE;EACE,eAAA;EACA,gBAAA;EACA,4DAAA;EACA,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,yBAAA;AARJ;AAWE;EACE,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AATJ;;AAaA;EAGM;IACE,iCAAA;EAZN;EAcI;IACE,iCAAA;EAZN;EAcI;IACE,iCAAA;EAZN;EAcI;IACE,iCAAA;EAZN;AACF;AAiBA;EAGM;IACE,iCAAA;EAjBN;EAmBI;IACE,iCAAA;EAjBN;EAkBM;IACE,SAAA;EAhBR;EAmBI;IACE,iCAAA;EAjBN;AACF;AAsBA;EAEI;IACE,YAAA;EArBJ;EAsBI;IACE,0BAAA;EApBN;EAsBI;IACE,0BAAA;IACA,8BAAA;EApBN;EAyBI;IACE,iCAAA;EAvBN;EAyBI;IACE,iCAAA;EAvBN;EAwBM;IACE,SAAA;EAtBR;EAyBI;IACE,iCAAA;EAvBN;AACF;AA4BA;EAGM;IACE,0BAAA;EA5BN;EA8BI;IACE,0BAAA;EA5BN;EAiCI;IACE,iCAAA;EA/BN;EAgCM;IACE,SAAA;EA9BR;EAiCI;IACE,iCAAA;EA/BN;EAiCI;IACE,iCAAA;EA/BN;EAgCM;IACE,SAAA;EA9BR;EAiCI;IACE,iCAAA;EA/BN;AACF;AAoCA;EAGM;IACE,iCAAA;EApCN;EAqCM;IACE,SAAA;EAnCR;EAsCI;IACE,iCAAA;EApCN;EAsCI;IACE,iCAAA;EApCN;EAqCM;IACE,SAAA;EAnCR;EAsCI;IACE,iCAAA;EApCN;AACF;AAyCA;EAIM;IACE,0BAAA;EA1CN;EA4CI;IACE,0BAAA;EA1CN;EA6CE;IACE,WAAA;IACA,YAAA;EA3CJ;EA4CI;IACE,iCAAA;EA1CN;EA2CM;IACE,SAAA;EAzCR;EA4CI;IACE,iCAAA;EA1CN;EA4CI;IACE,iCAAA;EA1CN;EA2CM;IACE,SAAA;EAzCR;EA4CI;IACE,iCAAA;EA1CN;AACF;AA+CA;EAIM;IACE,0BAAA;EAhDN;EAkDI;IACE,0BAAA;EAhDN;EAoDI;IACE,iCAAA;EAlDN;EAoDI;IACE,iCAAA;EAlDN;EAmDM;IACE,SAAA;EAjDR;EAoDI;IACE,iCAAA;EAlDN;AACF;AAuDA;EACE;IACE,WAAA;EArDF;EAuDI;IACE,0BAAA;EArDN;EAuDI;IACE,0BAAA;EArDN;EAwDE;IACE,WAAA;IACA,YAAA;EAtDJ;EAwDM;IACE,SAAA;EAtDR;EAyDI;IACE,iCAAA;EAvDN;EAyDI;IACE,iCAAA;EAvDN;EAwDM;IACE,SAAA;EAtDR;EAyDI;IACE,iCAAA;EAvDN;AACF;AA2DA;EACE;IACE,WAAA;EAzDF;EA2DI;IACE,0BAAA;EAzDN;EA2DI;IACE,0BAAA;EAzDN;EA6DI;IACE,iCAAA;EA3DN;EA6DI;IACE,iCAAA;EA3DN;EA4DM;IACE,SAAA;EA1DR;EA6DI;IACE,iCAAA;EA3DN;AACF;AAiEA;EACE;IACE,oBAAA;EA/DF;EAiEA;IACE,uBAAA;EA/DF;EAiEA;IACE,gBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EA/DF;EAiEA;IACE,UAAA;IACA,YAAA;EA/DF;EAiEE;IACE,SAAA;IACA,MAAA;IACA,6BAAA;EA/DJ;EAiEI;IACE,UAAA;IACA,iBAAA;IACA,aAAA;EA/DN;EAiEM;IACE,eAAA;EA/DR;EAiEM;IACE,eAAA;EA/DR;EAkEI;IACE,gCAAA;EAhEN;EAiEM;IACE,YAAA;EA/DR;EAkEI;IACE,gCAAA;EAhEN;EAmEI;IACE,gCAAA;EAjEN;EAkEM;IACE,YAAA;EAhER;EAmEI;IACE,gCAAA;EAjEN;AACF","sourcesContent":["@font-face {\r\n  font-family: \"GteDisplayBold\";\r\n  src: url('../../shared/font/gteestiprodisplay_bold.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: \"GteDisplayLight\";\r\n  src: url('../../shared/font/gteestiprodisplay_light.otf') format(\"truetype\");\r\n  font-style: normal;\r\n  font-weight: normal;\r\n}\r\n\r\n.body {\r\n  padding: 100px 0;\r\n  background: url(\"../../shared/images/roadMap_bg.png\") center no-repeat;\r\n  background-color: #000;\r\n  background-size: cover;\r\n  margin-top: 120px;\r\n}\r\n\r\n.wrapperMain {\r\n  margin: 250px 0 150px 0;\r\n}\r\n\r\n.line {\r\n  background: linear-gradient(90deg, #9747FF 0%, #0CD1E0 100%);\r\n  height: 8px;\r\n  width: 100%;\r\n  border-radius: 10px;\r\n  margin-top: 25px;\r\n  position: relative;\r\n  .point {\r\n    background: #13CBE2;\r\n    border-radius: 50px;\r\n    width: 20px;\r\n    height: 29px;\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translate(0, -50%);\r\n\r\n    .pointWrapper {\r\n      position: relative;\r\n    }\r\n\r\n    .pointItem {\r\n      position: absolute;\r\n      bottom: 5px;\r\n      left: 0;\r\n\r\n      h4 {\r\n        width: 100%;\r\n        text-wrap: nowrap;\r\n        font-size: 26px;\r\n        font-weight: 500;\r\n        background: linear-gradient(90deg, #9747FF 0%, #0CD1E0 100%);\r\n        font-family: GteDisplayBold;\r\n        -webkit-text-fill-color: transparent;\r\n        -webkit-background-clip: text;\r\n      }\r\n\r\n      .pointItemWrapper {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        grid-gap: 4px;\r\n        margin-top: 8px;\r\n        p {\r\n          font-family: GteDisplayLight;\r\n          color: #fff;\r\n          text-wrap: none;\r\n          white-space: nowrap;\r\n          overflow-wrap: normal;\r\n          word-wrap: normal;\r\n          hyphens: none;\r\n          position: relative;\r\n          padding-left: 12px;\r\n          &::before {\r\n            content: \"\";\r\n            display: block;\r\n            width: 5px;\r\n            height: 2px;\r\n            background: #fff;\r\n            position: absolute;\r\n            left: 0;\r\n            top: 50%;\r\n            transform: translate(0, -50%);\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    &:nth-child(2) {\r\n      transform: translate(250px, -50%);\r\n\r\n      .pointItem {\r\n        top: 55px;\r\n      }\r\n    }\r\n    &:nth-child(3) {\r\n      transform: translate(620px, -50%);\r\n    }\r\n    &:nth-child(4) {\r\n      transform: translate(900px, -50%);\r\n      .pointItem {\r\n        top: 55px;\r\n      }\r\n    }\r\n    &:nth-child(5) {\r\n      transform: translate(900px, -50%);\r\n    }\r\n  }\r\n\r\n\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  max-width: 800px;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  text-align: center;\r\n  grid-gap: 10px;\r\n  color: #111827;\r\n  font-family: Inter;\r\n\r\n  h3 {\r\n    font-size: 48px;\r\n    font-weight: 700;\r\n    background: linear-gradient(90deg, #9747FF 0%, #0CD1E0 100%);\r\n    font-family: GteDisplayBold;\r\n    -webkit-text-fill-color: transparent;\r\n    -webkit-background-clip: text;\r\n    text-transform: uppercase;\r\n  }\r\n\r\n  p {\r\n    font-family: GteDisplayLight;\r\n    font-size: 16px;\r\n    line-height: 20px;\r\n    font-weight: 400;\r\n    color: #ffffff;\r\n  }\r\n}\r\n\r\n@media (max-width: 1450px) {\r\n  .line {\r\n    .point {\r\n      &:nth-child(2) {\r\n        transform: translate(200px, -50%);\r\n      }\r\n      &:nth-child(3) {\r\n        transform: translate(550px, -50%);\r\n      }\r\n      &:nth-child(4) {\r\n        transform: translate(750px, -50%);\r\n      }\r\n      &:nth-child(5) {\r\n        transform: translate(850px, -50%);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 1205px) {\r\n  .line {\r\n    .point {\r\n      &:nth-child(2) {\r\n        transform: translate(100px, -50%);\r\n      }\r\n      &:nth-child(4) {\r\n        transform: translate(700px, -50%);\r\n        .pointItem {\r\n          top: 55px;\r\n        }\r\n      }\r\n      &:nth-child(5) {\r\n        transform: translate(850px, -50%);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .line {\r\n    .pointItem {\r\n      width: 300px;\r\n      h4 {\r\n        font-size: 22px !important;\r\n      }\r\n      p {\r\n        font-size: 15px !important;\r\n        white-space: normal !important;\r\n      }\r\n    }\r\n\r\n    .point {\r\n      &:nth-child(3) {\r\n        transform: translate(500px, -50%);\r\n      }\r\n      &:nth-child(4) {\r\n        transform: translate(600px, -50%);\r\n        .pointItem {\r\n          top: 55px;\r\n        }\r\n      }\r\n      &:nth-child(5) {\r\n        transform: translate(850px, -50%);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 960px) {\r\n  .line {\r\n    .pointItem {\r\n      h4 {\r\n        font-size: 22px !important;\r\n      }\r\n      p {\r\n        font-size: 15px !important;\r\n      }\r\n    }\r\n\r\n    .point {\r\n      &:nth-child(2) {\r\n        transform: translate(250px, -50%);\r\n        .pointItem {\r\n          top: 55px;\r\n        }\r\n      }\r\n      &:nth-child(3) {\r\n        transform: translate(420px, -50%);\r\n      }\r\n      &:nth-child(4) {\r\n        transform: translate(630px, -50%);\r\n        .pointItem {\r\n          top: 55px;\r\n        }\r\n      }\r\n      &:nth-child(5) {\r\n        transform: translate(750px, -50%);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 960px) {\r\n  .line {\r\n    .point {\r\n      &:nth-child(2) {\r\n        transform: translate(150px, -50%);\r\n        .pointItem {\r\n          top: 55px;\r\n        }\r\n      }\r\n      &:nth-child(3) {\r\n        transform: translate(350px, -50%);\r\n      }\r\n      &:nth-child(4) {\r\n        transform: translate(530px, -50%);\r\n        .pointItem {\r\n          top: 55px;\r\n        }\r\n      }\r\n      &:nth-child(5) {\r\n        transform: translate(680px, -50%);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 840px) {\r\n  .line {\r\n    .pointItem {\r\n\r\n      h4 {\r\n        font-size: 20px !important;\r\n      }\r\n      p {\r\n        font-size: 14px !important;\r\n      }\r\n    }\r\n    .point {\r\n      width: 15px;\r\n      height: 22px;\r\n      &:nth-child(2) {\r\n        transform: translate(100px, -50%);\r\n        .pointItem {\r\n          top: 55px;\r\n        }\r\n      }\r\n      &:nth-child(3) {\r\n        transform: translate(300px, -50%);\r\n      }\r\n      &:nth-child(4) {\r\n        transform: translate(500px, -50%);\r\n        .pointItem {\r\n          top: 55px;\r\n        }\r\n      }\r\n      &:nth-child(5) {\r\n        transform: translate(630px, -50%);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 840px) {\r\n  .line {\r\n    .pointItem {\r\n\r\n      h4 {\r\n        font-size: 20px !important;\r\n      }\r\n      p {\r\n        font-size: 14px !important;\r\n      }\r\n    }\r\n    .point {\r\n      &:nth-child(3) {\r\n        transform: translate(275px, -50%);\r\n      }\r\n      &:nth-child(4) {\r\n        transform: translate(450px, -50%);\r\n        .pointItem {\r\n          top: 55px;\r\n        }\r\n      }\r\n      &:nth-child(5) {\r\n        transform: translate(550px, -50%);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 700px) {\r\n  .line {\r\n    height: 4px;\r\n    .pointItem {\r\n      h4 {\r\n        font-size: 18px !important;\r\n      }\r\n      p {\r\n        font-size: 12px !important;\r\n      }\r\n    }\r\n    .point {\r\n      width: 10px;\r\n      height: 15px;\r\n      &:nth-child(2) {\r\n        .pointItem {\r\n          top: 30px;\r\n        }\r\n      }\r\n      &:nth-child(3) {\r\n        transform: translate(250px, -50%);\r\n      }\r\n      &:nth-child(4) {\r\n        transform: translate(400px, -50%);\r\n        .pointItem {\r\n          top: 30px;\r\n        }\r\n      }\r\n      &:nth-child(5) {\r\n        transform: translate(500px, -50%);\r\n      }\r\n    }\r\n  }\r\n}\r\n@media (max-width: 635px) {\r\n  .line {\r\n    height: 4px;\r\n    .pointItem {\r\n      h4 {\r\n        font-size: 18px !important;\r\n      }\r\n      p {\r\n        font-size: 12px !important;\r\n      }\r\n    }\r\n    .point {\r\n      &:nth-child(3) {\r\n        transform: translate(250px, -50%);\r\n      }\r\n      &:nth-child(4) {\r\n        transform: translate(350px, -50%);\r\n        .pointItem {\r\n          top: 30px;\r\n        }\r\n      }\r\n      &:nth-child(5) {\r\n        transform: translate(450px, -50%);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n@media (max-width: 430px) {\r\n  .body {\r\n    padding-bottom: 50px;\r\n  }\r\n  .pointItem {\r\n    width: 180px !important;\r\n  }\r\n  .wrapperMain {\r\n    margin-top: 50px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .line {\r\n    width: 4px;\r\n    height: 75vh;\r\n\r\n    .point {\r\n      left: 50%;\r\n      top: 0;\r\n      transform: translate(-50%, 0);\r\n\r\n      .pointItem {\r\n        left: 150%;\r\n        top: 0 !important;\r\n        z-index: 1000;\r\n\r\n        h4 {\r\n          font-size: 21px;\r\n        }\r\n        p {\r\n          font-size: 15px;\r\n        }\r\n      }\r\n      &:nth-child(2) {\r\n        transform: translate(-50%, 18vh);\r\n        .pointItem {\r\n          left: -180px;\r\n        }\r\n      }\r\n      &:nth-child(3) {\r\n        transform: translate(-50%, 35vh);\r\n        \r\n      }\r\n      &:nth-child(4) {\r\n        transform: translate(-50%, 53vh);\r\n        .pointItem {\r\n          left: -180px;\r\n        }\r\n      }\r\n      &:nth-child(5) {\r\n        transform: translate(-50%, 73vh);\r\n      }\r\n\r\n\r\n    }\r\n  }\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `roadMap_body__OiyJk`,
	"wrapperMain": `roadMap_wrapperMain__RGBpA`,
	"line": `roadMap_line__fjw6S`,
	"point": `roadMap_point__91jRP`,
	"pointWrapper": `roadMap_pointWrapper__5Sf6A`,
	"pointItem": `roadMap_pointItem__rOzdL`,
	"pointItemWrapper": `roadMap_pointItemWrapper__SMPia`,
	"header": `roadMap_header__b+a-v`
};
export default ___CSS_LOADER_EXPORT___;
